import { getUrlParams } from "@/utils/index";
export var H5_ID = 'tmp_h5_20201031';
export var actId = getActId();
export var STATUS;

(function (STATUS) {
  /** 0 未开始 */
  STATUS[STATUS["NOT_START"] = 0] = "NOT_START";
  /** 1 报名中 */

  STATUS[STATUS["JOIN"] = 1] = "JOIN";
  /** 2 待直播 */

  STATUS[STATUS["PRE_LIVE"] = 2] = "PRE_LIVE";
  /** 3 直播中 */

  STATUS[STATUS["LIVE"] = 3] = "LIVE";
  /** 4 直播抢修中 */

  STATUS[STATUS["IN_FIX"] = 4] = "IN_FIX";
  /** 5 回看配置中 */

  STATUS[STATUS["CONF_REPLAY"] = 5] = "CONF_REPLAY";
  /** 6 回看中 */

  STATUS[STATUS["REPLAY"] = 6] = "REPLAY";
  /** 7 已结束 */

  STATUS[STATUS["END"] = 7] = "END";
})(STATUS || (STATUS = {}));

function getActId() {
  var urlParam = getUrlParams();
  var reqActId = 'vdc2020';

  if (urlParam && urlParam.actId) {
    reqActId = urlParam.actId;
  }

  return reqActId;
}